import { z } from 'zod';

export const HealthLiveSchema = z.object({
  status: z.literal('ok'),
  service: z.string(),
  version: z.string(),
  time: z.string(),
});
export type HealthLive = z.infer<typeof HealthLiveSchema>;

export const DependencyStatusSchema = z.object({
  name: z.string(),
  ok: z.boolean(),
  latencyMs: z.number(),
  error: z.string().optional(),
});
export type DependencyStatus = z.infer<typeof DependencyStatusSchema>;

export const HealthReadySchema = z.object({
  status: z.enum(['ready', 'degraded']),
  checks: z.array(DependencyStatusSchema),
});
export type HealthReady = z.infer<typeof HealthReadySchema>;
